import { Controller } from '@hotwired/stimulus';

// Displays flash messages via toastr on connect. Works with dynamically
// inserted DOM (Turbo Stream appends), where an inline <script> never runs.
export default class extends Controller {
  static values = {
    messages: { type: Array, default: [] },
  };

  connect() {
    this.messagesValue.forEach(({ type, title, message }) => {
      window.toastr[type](message, title, { closeButton: true });
    });
  }
}
